module.exports = __webpack_public_path__ + "static/media/PayRoll3.8ef7d27f.png";